import CartSinglePagePayment from './CartSinglePagePayment'

export default CartSinglePagePayment
// eslint-disable-next-line import/export
export * from './CartSinglePagePayment'
